function initPasswordToggle() {
  document.querySelectorAll('[data-password-toggle]').forEach((button) => {
    // Skip if already initialized
    if (button.dataset.toggleInitialized) return
    button.dataset.toggleInitialized = 'true'

    button.addEventListener('click', (e) => {
      e.preventDefault()

      const input = button.closest('.input-group')?.querySelector('input[type="password"], input[type="text"]')

      if (input) {
        if (input.type === 'password') {
          input.type = 'text'
          button.innerHTML = '<i class="bi bi-eye-slash grow"></i>'
        } else {
          input.type = 'password'
          button.innerHTML = '<i class="bi bi-eye grow"></i>'
        }
      }
    })
  })
}

// Run on page load and after Turbo navigation
document.addEventListener('turbo:load', initPasswordToggle)
document.addEventListener('DOMContentLoaded', initPasswordToggle)